<template>
  <v-row no-gutters justify="space-between" class="rowContent mt-0">
    <!-- avatar -->
    <v-col cols="10">
      <div class="d-flex avatarBox" v-if="item.poster">
        <AvatarComponent size="42" :url="item.poster.picture" />
        <div class="boxedContent mx-3">
          <h5 class="text-md-subtitle-1 body-2">
            <strong>
              {{ item.poster.name }}
            </strong>
          </h5>
          <p class="grey--text caption mb-0">{{ item.createdDate | ago }}</p>
        </div>
      </div>
    </v-col>
    <v-col cols="12" class="mt-5">
      <div class="black--text body-1">
        <component v-bind:is="transformed"></component>
      </div>
    </v-col>
  </v-row>
</template>
<script>
export default {
  name: 'PostHeaderMedia',
  props: ["item"],
  computed: {
    transformed () {
      const template = '<span>' + this.item.description.replace(
        /<a\shref=\"([a-zA-Z0-9\-]+)gammarSplitter([a-zA-Z0-9\-]+)\">([^\<]+)<\/a>/g, 
        '<router-link \
          :to="{\
            name: \'courses.home\',\
            params: {\
              coursesCountry: \'$1\',\
              namegolf: \'$2\',\
            },\
          }\
        ">$3</router-link>'
      ) + '</span>'
      return {template}
    }
  },
};
</script>
